<app-bulk-upload-content
  [fields]="fields"
  [bulkExample]="bulkExample"
  [fileUploadError]="fileUploadError()"
  (onTextareaUpload)="uploadProductGroups($event)"
  (onCsvFileUpload)="onCsvUpload($event)"
/>
